itsoftApp.createModule("disclaimer", ["windowResize"], function () {
    var pageFooter = document.querySelector(".page-footer");
    var disclaimer = document.querySelector(".js-disclaimer"); /* У дисклеймера должен быть такой класс */
    var disclaimerButton = document.querySelector(".disclaimer__close-button"); /* Крестик */
    var disclaimerConfirm = document.querySelector(".disclaimer__confirm"); /* элемент подтвеждения закрытия */
    // var lwrapper = document.querySelector(".l-wrapper");

    var buttonMouseOver = function () { //evt
        if (!disclaimer.classList.contains("js-hover")) {
            disclaimer.classList.add("js-hover");
            disclaimerConfirm.addEventListener("mouseout", buttonMouseOut);
        }
    };

    var buttonMouseOut = function () { //evt
        disclaimer.classList.remove("js-hover");
        disclaimerConfirm.removeEventListener("mouseout", buttonMouseOut);
    };

    var disclaimerClose = function () {
        disclaimer.classList.add("js-static");
        disclaimer.classList.add("js-inactive");
        if (disclaimer.classList.contains("js-hover")) {
            disclaimer.classList.remove("js-hover");
        }
        disclaimerConfirm.style.display = "none";
        pageFooter.classList.add("js-update");
    };

    if (disclaimerButton) {
        disclaimerButton.addEventListener("mouseover", buttonMouseOver);

        disclaimerButton.addEventListener("click", function (evt) {
            evt.preventDefault();
            disclaimerClose();
        });
    }

    if (disclaimerConfirm) {
        disclaimerConfirm.addEventListener("click", function (evt) {
            evt.preventDefault();
            disclaimerClose();
        });
    }

    var footerCoordY;

    var defineCoordY = function () {
        footerCoordY = pageFooter.getBoundingClientRect().top + pageYOffset;
    };

    /* Вычисляем координаты. Если мы прокрутили страницу до подвала, делаем дисклеймер статичным */
    var checkElementCoords = function () {
        var sTop = pageYOffset;

        if (sTop + document.documentElement.clientHeight > footerCoordY) {
            if (disclaimerButton) {
                disclaimerButton.classList.add("js-close-hide");
            }
            disclaimer.classList.add("js-inactive");
        } else if (!disclaimer.classList.contains("js-static")) {
            if (disclaimerButton) {
                disclaimerButton.classList.remove("js-close-hide");
            }
            disclaimer.classList.remove("js-inactive");
        } else {
            document.removeEventListener("scroll", onDocumentScroll);
            window.removeEventListener("resize", onDocumentResize);
        }
    };

    var onDocumentScroll = function () {
        defineCoordY();
        checkElementCoords();
    };

    var onDocumentResize = function () {
        /* Обновляем координаты при ресайзе */
        defineCoordY();
        checkElementCoords();
    };

    if (disclaimer) {
        /* Иниөиализируем модулҗ после полной загрузки страницы, только если на странице есть дисклеймер */
        itsoftApp.modules.pageLoad.addEvent(function () {
            defineCoordY();
            checkElementCoords();

            document.addEventListener("scroll", onDocumentScroll);
            window.addEventListener("resize", onDocumentResize);
        });
    }
});